export class LoginCredential {
    login: string;
    password: string;

    public constructor(login: string, password: string) {
        this.login = login;
        this.password = password;
    }
}